import type { RoleLight, Permission } from "./Role";

export interface User {
    id?: string;    
    firstName: string;
    lastName: string;
    email: string;
    enabled: boolean;
    status: string;
    roles: RoleLight[];
    locationIds?: string[];
}

export const getUserFullName = (user: User): string =>
    `${user.firstName} ${user.lastName}`;

export function createUser(): User {
    return {
        id: undefined,
        firstName: '',
        lastName: '',
        email: '',
        enabled: true,
        status: 'unknown',
        roles: [],
        locationIds: []
    };
}

export interface UserLight {
    id: string;    
    firstName: string;
    lastName: string;
    email: string;
}

export interface CurrentUser {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    permissions: Permission[]
    /**
     * The locations this user is assigned to. An EMPTY array means no locations at all — not "unrestricted"
     * (TTD-160).
     *
     * Optional because the field is absent from an API older than this build, and a portal that deploys ahead
     * of one would otherwise read "no field" as "no access" and lock every user out of the scope picker.
     * Absent = unknown, and unknown is not filtered.
     */
    locationIds?: string[];
}
